import { Route } from "../../navigation/routes";

export const menu: Route[] = [
  {
    name: "Кейсы",
    image: "",
    href: "/cases",
  },
  {
    name: "Оформить заказ",
    image: "",
    href: "/order",
  },
  {
    name: "Список услуг",
    image: "",
    href: "/services",
  },
  {
    name: "Отзывы",
    image: "",
    href: "https://yandex.ru/maps/org/fkor/148510060533/?ll=37.624498%2C55.754826&z=16",
  },
];
